import { IService, ServiceEvent } from '../base/BaseService';
import { ITranscriptContainer } from '../../models/interfaces';

/**
 * Timeline events emitted by the TimelineService
 */
export enum TimelineEvent {
  ACTIVE_ELEMENT_CHANGED = 'active_element_changed',
  ELEMENT_POSITIONS_CHANGED = 'element_positions_changed',
  PROCESSING_COMPLETE = 'processing_complete'
}

/**
 * Make TimelineEvent compatible with ServiceEvent
 */
// Enum extends implicitly

/**
 * Element position on the timeline
 */
export interface ElementPosition {
  id: string;
  elementId: string;
  startTime: number;
  endTime: number;
  text: string;
  isPunctuation: boolean;
  paragraphId: string;
  segmentId: string;
}

/**
 * Timeline metadata
 */
export interface TimelineMetadata {
  totalDuration: number;
  elementCount: number;
  hasTiming: boolean;
}

/**
 * Interface for the timeline service
 */
export interface ITimelineService extends IService<TimelineEvent> {
  /**
   * Processes transcript data to create a timeline visualization
   */
  processTranscript(container: ITranscriptContainer, audioDuration?: number): TimelineMetadata;
  
  /**
   * Get all element positions for timeline visualization
   */
  getElementPositions(): Map<string, ElementPosition>;
  
  /**
   * Find the element at a specific time
   */
  getElementAtTime(time: number): ElementPosition | null;
  
  /**
   * Get the position of a specific element
   */
  getElementPosition(elementId: string): ElementPosition | null;
  
  /**
   * Clears the timeline
   */
  clear(): void;
  
  /**
   * Check if the timeline has been processed
   */
  isProcessed(): boolean;
  
  /**
   * Set the active element ID
   */
  setActiveElement(elementId: string | null): void;
  
  /**
   * Total duration of the timeline in seconds
   */
  readonly totalDuration: number;
  
  /**
   * Currently active element ID
   */
  readonly activeElementId: string | null;
}